import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Phone, Mail, MapPin, Clock, Facebook, Twitter, Instagram } from 'lucide-react';
export const Footer = () => {
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Service Coverage',
    path: '/service-coverage'
  }, {
    name: 'About Us',
    path: '/about-us'
  }, {
    name: 'Contact Us',
    path: '/contact-us'
  }, {
    name: 'FAQs',
    path: '/faqs'
  }];
  const policyLinks = [{
    name: 'Cancellation Policy',
    path: '/cancellation-policy'
  }, {
    name: 'Refund Policy',
    path: '/refund-policy'
  }, {
    name: 'Privacy Policy',
    path: '/privacy-policy'
  }, {
    name: 'Terms & Conditions',
    path: '/terms-and-conditions'
  }];
  const openingHours = [{
    day: 'Monday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Tuesday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Wednesday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Thursday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Friday',
    hours: '9:00am – 5:00pm'
  }, {
    day: 'Saturday',
    hours: 'Closed'
  }, {
    day: 'Sunday',
    hours: 'Closed'
  }];
  return <footer className="bg-primary text-white w-full" data-id="element-61">
      <div className="container mx-auto px-4 py-12" data-id="element-62">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-63">
          {/* Company Info */}
          <div data-id="element-64">
            <div className="mb-4" data-id="element-65">
              <Logo data-id="element-66" />
            </div>
            <p className="text-light/90 mt-4 mb-6" data-id="element-67">
              Professional appliance repairs and maintenance services you can
              trust. Providing expert care for your home appliances across the
              UK.
            </p>
            <div className="flex space-x-4" data-id="element-68">
              <a href="#" className="text-white hover:text-secondary" data-id="element-69">
                <Facebook size={20} data-id="element-70" />
              </a>
              <a href="#" className="text-white hover:text-secondary" data-id="element-71">
                <Twitter size={20} data-id="element-72" />
              </a>
              <a href="#" className="text-white hover:text-secondary" data-id="element-73">
                <Instagram size={20} data-id="element-74" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-75">
            <h3 className="text-lg font-bold mb-4" data-id="element-76">Quick Links</h3>
            <ul className="space-y-2" data-id="element-77">
              {navLinks.map(link => <li key={link.path} data-id="element-78">
                  <Link to={link.path} className="text-light/90 hover:text-secondary transition-colors" data-id="element-79">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
          {/* Policies */}
          <div data-id="element-80">
            <h3 className="text-lg font-bold mb-4" data-id="element-81">Policies</h3>
            <ul className="space-y-2" data-id="element-82">
              {policyLinks.map(link => <li key={link.path} data-id="element-83">
                  <Link to={link.path} className="text-light/90 hover:text-secondary transition-colors" data-id="element-84">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
          {/* Contact & Hours */}
          <div data-id="element-85">
            <h3 className="text-lg font-bold mb-4" data-id="element-86">Contact Us</h3>
            <ul className="space-y-3" data-id="element-87">
              <li className="flex items-start" data-id="element-88">
                <MapPin size={18} className="mr-2 mt-1 flex-shrink-0" data-id="element-89" />
                <span data-id="element-90">78 Austhorpe Rd, Leeds LS15 8EF</span>
              </li>
              <li className="flex items-center" data-id="element-91">
                <Phone size={18} className="mr-2 flex-shrink-0" data-id="element-92" />
                <a href="tel:08000554969" className="hover:text-secondary" data-id="element-93">
                  0800 055 4969
                </a>
              </li>
              <li className="flex items-center" data-id="element-94">
                <Mail size={18} className="mr-2 flex-shrink-0" data-id="element-95" />
                <a href="mailto:rawalraj2057@gmail.com" className="hover:text-secondary" data-id="element-96">
                  rawalraj2057@gmail.com
                </a>
              </li>
            </ul>
            <h3 className="text-lg font-bold mt-6 mb-4 flex items-center" data-id="element-97">
              <Clock size={18} className="mr-2" data-id="element-98" />
              Opening Hours
            </h3>
            <ul className="space-y-1" data-id="element-99">
              {openingHours.map((item, index) => <li key={index} className="flex justify-between text-sm" data-id="element-100">
                  <span className="font-medium" data-id="element-101">{item.day}:</span>
                  <span data-id="element-102">{item.hours}</span>
                </li>)}
            </ul>
          </div>
        </div>
        {/* Payment Methods & Copyright */}
        <div className="border-t border-white/20 pt-6 mt-6 flex flex-col md:flex-row justify-between items-center" data-id="element-103">
          <div className="mb-4 md:mb-0" data-id="element-104">
            <p className="text-sm text-light/80" data-id="element-105">
              © {new Date().getFullYear()} Prismedge. All rights reserved.
            </p>
          </div>
          <div className="flex gap-3" data-id="element-106">
            <img src="https://cdn-icons-png.flaticon.com/512/196/196578.png" alt="Visa" className="h-8 bg-white p-1 rounded" data-id="element-107" />
            <img src="https://cdn-icons-png.flaticon.com/512/196/196561.png" alt="Mastercard" className="h-8 bg-white p-1 rounded" data-id="element-108" />
            <img src="https://cdn-icons-png.flaticon.com/512/174/174861.png" alt="PayPal" className="h-8 bg-white p-1 rounded" data-id="element-109" />
          </div>
        </div>
      </div>
    </footer>;
};